export default "__VITE_ASSET__4fe48771__"